module.exports = __webpack_public_path__ + "static/img/banner3.5edbcc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner3.png
// module id = a+7/
// module chunks = 1